export function parseCompletion(text) {
    const startIndex = text.indexOf('[');
    const endIndex = text.lastIndexOf(']');
    const subString = text.slice(startIndex, endIndex + 1);
    const finalSring = subString.replace(/\n/g, '')?.trim();
    return JSON.parse(finalSring);
}